/*
Author : Arman Ali
Module: Department
github: https://github.com/Arman-Arzoo
*/

import { createAsyncThunk } from '@reduxjs/toolkit';
import { apiInstanceV2 } from '../../Apis/AxiosV2';
import { apiInstance } from '../../Apis/Axios';
import { UploadImage } from '../ShareSlice/shareApi';
import { DOCUMENT_SERVICE, EMPLOYEE_SERVICE, EXTRA_DATA_SERVICE, VERIDAS_SERVICE } from '../EndPoints';

// List all the Employee
export const GetAllEmployees = createAsyncThunk(
    'employeeSection/getAllEmployees',
    async (params) => {
        const result = await apiInstanceV2
            .post(EMPLOYEE_SERVICE.getAllEmployees, params)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);

// create employee /create company-module employee-controller
export const CreateEmployeeUser = createAsyncThunk(
    'employeeSection/createEmployeeUser',
    async (params, { dispatch, getState }) => {
        const result = await apiInstance
            .post(EMPLOYEE_SERVICE.createEmployeeUser, params)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);

// Get Employee by Id /get-by-user-id company-module employee-controller
export const GetEmployeeDetailsByUserId = createAsyncThunk(
    'employeeSection/getEmployeeDetailsByUserId',
    async (userId) => {
        const result = await apiInstance
            .get(`${EMPLOYEE_SERVICE.getEmployeeDetailsByUserId}${userId}`)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);
// Get Employee extra data for VCard
export const GetExtraDataService = createAsyncThunk(
    'employeeSection/getExtraDataService',
    async (params, { dispatch, getState }) => {
        const result = await apiInstance
            .get(EXTRA_DATA_SERVICE.getExtraDataService, params)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);
//vcard settings
export const GetVCardSettings = createAsyncThunk(
    'employeeSection/getVCardSettings',
    async (params, { dispatch, getState }) => {
        const result = await apiInstance
            .get('vcard-service/v1/get', params)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);
export const UpdateVCardSettings = createAsyncThunk(
    'employeeSection/updateVCardSettings',
    async (params, { dispatch, getState }) => {
        const result = await apiInstance
            .put('vcard-service/v1/update', params)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);

// update employee /update company-module employee-controller

export const UpdateEmployeeUser = createAsyncThunk(
    'employeeSection/updateEmployeeUser',
    async (params, { dispatch, getState }) => {
        const result = await apiInstance
            .put(EMPLOYEE_SERVICE.updateEmployeeUser, params)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);

// corporate-user-pre-prod-v2/document-service/employee/approve-document (done)
export const ApproveCompanyEmployeeDocument = createAsyncThunk(
    'employeeSection/approveCompanyEmployeeDocument',
    async (params, { dispatch, getState }) => {
        const result = await apiInstance
            .post(DOCUMENT_SERVICE.approveCompanyEmployeeDocument, params)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);

// Documents for employee
export const GetAllEmployeeDocuments = createAsyncThunk('employeeSection/getAllEmployeeDocuments', async (id) => {
    const result = await apiInstanceV2
        .get(`${DOCUMENT_SERVICE.getAllEmployeeDocuments}${id}`)
        .then(function (response) {
            if (response.status == 201 || response.status == 200) {

            }
            return response;
        })
        .catch(function (error) {
            //   toast.error("Company Restriction Faild");
            return error.response;
        });
    const { data, status } = result;
    return { data, status };
});

// set document employee value
export const SetEmployeeDocValue = createAsyncThunk(
    'employeeSection/setEmployeeDocValue',
    async (params, { dispatch, getState }) => {
        const result = await apiInstanceV2
            .put(DOCUMENT_SERVICE.setEmployeeDocValue, params)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;
        return { data, status };
    },
);

// create document employee value
export const CreateEmployeeDocValue = createAsyncThunk(
    'employeeSection/createEmployeeDocValue',
    async (params, { dispatch, getState }) => {
        const result = await apiInstance
            .post(DOCUMENT_SERVICE.createEmployeeDocValue, params?.data)
            .then(function (response) {
                if (params?.file) {
                    const formData = new FormData();
                    formData.append('id', response?.data?.data?.id);
                    formData.append('option', 'employee_document');
                    formData.append('file', params?.file);
                    dispatch(UploadImage(formData));
                }
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;
        return { data, status };
    },
);

export const GetServiceById = createAsyncThunk('employeeSection/getServiceById', async (id) => {
    const result = await apiInstanceV2
        .get(`${VERIDAS_SERVICE.getServiceById}${id}`)
        .then(function (response) {
            return response;
        })
        .catch(function (error) {
            return error.response;
        });
    const { data, status } = result;
    return { data, status };
});
